<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-button class="mb-3" variant="danger" @click="goBack">Voltar</b-button>
    <b-card>
      <b-row>
        <b-col xl="6" lg="6" md="12" sm="12">
          <h4
            class="mb-0 f-g"
          >Período de Compras: {{moment(periodoInicialCompras).format("DD/MM/YYYY")}} à {{moment(periodoFinalCompras).format("DD/MM/YYYY")}}</h4>
        </b-col>
        <b-col xl="6" lg="6" md="12" sm="12">
          <h4
            class="mb-0 f-g"
          >Período de Ausência: {{moment(periodoInicialAusencia).format("DD/MM/YYYY")}} à {{moment(periodoFinalAusencia).format("DD/MM/YYYY")}}</h4>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col sm="12" md="6" lg="6" xl="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ clientesNaoFidelizados }}</h4>
            <p>Clientes não fidelizados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="12" md="6" lg="6" xl="6">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ clientesFidelizados }}</h4>
            <p>Clientes fidelizados</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-card header-tag="header" v-if="items_clientesfidelizados.length > 0">
      <template slot="header">
        <h4 class="float-left pt-1">
          <strong>Clientes fidelizados</strong>
        </h4>
        <b-button variant="outline-success" class="float-right" @click="redirect">
          <strong>
            Criar campanha
            <i class="fa fa-plus-square" style="font-size:14px;"></i>
          </strong>
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-table
            bordered
            small
            hover
            head-variant="light"
            style="margin-bottom: 0!important; padding-bottom: 0!important;"
            :items="items_clientesfidelizados"
            :fields="fields_clientes"
            sort-direction="desc"
            class="w-100"
          ></b-table>
        </b-col>
      </b-row>
    </b-card>
    <b-card header-tag="header" v-if="items_produtoscomparados.length > 0">
      <template slot="header">
        <h4 class="float-left pt-1">
          <strong>Produtos comparados</strong>
        </h4>
      </template>
      <b-row>
        <b-col>
          <b-table
            bordered
            small
            hover
            head-variant="light"
            style="margin-bottom: 0!important; padding-bottom: 0!important;"
            :items="items_produtoscomparados"
            :fields="fields_produtos"
            @row-clicked="analiseItemSelecionado"
            sort-direction="desc"
            class="w-100"
          >
            <template
              slot="qtdvendida"
              slot-scope="data"
            >{{ (parseFloat(data.item.qtdvendida).toFixed(2)).toLocaleString('pt-br') }}</template>
            <template
              slot="valorunitariovendido"
              slot-scope="data"
            >R$ {{ (data.item.valorunitariovendido.toFixed(2)).toLocaleString('pt-br') }}</template>
            <template
              slot="valortotalvendido"
              slot-scope="data"
            >R$ {{ (data.item.valortotalvendido.toFixed(2)).toLocaleString('pt-br') }}</template>
            <template
              slot="valoratualproduto"
              slot-scope="data"
            >R$ {{data.item.valorpromocionalatualproduto > 0 ? (data.item.valorpromocionalatualproduto.toFixed(2)).toLocaleString('pt-br') : (data.item.valoratualproduto.toFixed(2)).toLocaleString('pt-br')}}</template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
    <b-modal ref="enviarCampanha" title="Enviar campanha" hide-footer centered>
      <b-alert variant="danger" class="mb-3" show v-if="erroCampanha">Verifique os campos.</b-alert>
      <b-row>
        <b-col cols="6">
          <span>
            <strong>Pushs disponíveis:</strong>
            {{ pushsDisponiveis }}
          </span>
        </b-col>
        <b-col cols="6">
          <span>
            <strong>A enviar:</strong>
            {{ items_clientesfidelizados.length }}
          </span>
        </b-col>
      </b-row>
      <b-input-group prepend="Título" class="mt-3">
        <b-form-input v-model="tituloCampanha" />
      </b-input-group>
      <b-input-group prepend="Descrição" class="mt-3">
        <b-form-input v-model="descricaoCampanha" />
      </b-input-group>
      <b-input-group prepend="Vínculo" class="mt-3">
        <b-form-select
          v-model="vinculoSelecionado"
          :options="vinculos"
          @change="escolheuInteresse"
        />
      </b-input-group>
      <b-input-group
        prepend="Promoções"
        class="mt-3"
        v-if="vinculoSelecionado == 2 && listaPromocoes.length > 0"
      >
        <b-form-select
          v-model="promocaoSelecionada"
          :options="listaPromocoes"
          @change="escolheuInteresse"
        />
      </b-input-group>
      <b-button class="mt-3 w-100" variant="success" @click="enviarCampanha">Enviar campanha</b-button>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  components: {
    Loading
  },
  data: _ => {
    return {
      erroCampanha: false,
      isLoading: false,
      pushsDisponiveis: 0,
      tituloCampanha: null,
      descricaoCampanha: null,
      listaPromocoes: [],
      promocaoSelecionada: null,
      vinculos: [
        {
          value: null,
          text: "Sem vínculo"
        },
        {
          value: 1,
          text: "Jornalzinho"
        },
        {
          value: 2,
          text: "Promoções"
        },
        {
          value: 3,
          text: "Sorteios"
        },
        {
          value: 4,
          text: "Cupons"
        }
      ],
      vinculoSelecionado: null,
      periodoInicialCompras: null,
      periodoFinalCompras: null,
      periodoInicialAusencia: null,
      periodoFinalAusencia: null,
      clientesFidelizados: null,
      clientesNaoFidelizados: null,
      items_clientesfidelizados: [],
      items_produtoscomparados: [],
      fields_clientes: [
        { key: "cpfcnpj", label: "CPF" },
        { key: "nome", label: "Nome" },
        { key: "sobrenome", label: "Sobrenome" },
        { key: "apelido", label: "Apelido" }
      ],
      fields_produtos: [
        { key: "codbarras", label: "Barras" },
        { key: "descricao", label: "Descrição" },
        { key: "qtdvendida", label: "Quantidade Vendida" },
        { key: "valorunitariovendido", label: "Valor Vendido" },
        { key: "valortotalvendido", label: "Valor Total Vendido" },
        { key: "valoratualproduto", label: "Valor Atual" }
      ]
    };
  },
  methods: {
    verificarCamposCampanha() {
      if (this.tituloCampanha == null || this.tituloCampanha == "")
        return false;
      if (this.descricaoCampanha == null || this.descricaoCampanha == "")
        return false;
      if (this.vinculoSelecionado == 2 && this.promocaoSelecionada == null)
        return false;

      return true;
    },
    async escolheuInteresse() {
      if (this.vinculoSelecionado == 2) await this.getIDPromocoes();
    },
    async getIDPromocoes() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/id-promocoes/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.listaPromocoes = response.data.data;
          }
        });
    },
    async enviarCampanha() {
      if (this.verificarCamposCampanha()) {
        this.erroCampanha = false;
        var arrClientes = [];
        for (let i = 0; i < this.clientesFidelizados.length; i++) {
          const e = this.clientesFidelizados[i];
          arrClientes.push(e.id);
        }
        await axios
          .put(
            `${config.default.servidor}/gerencial/inserir-envio-push`,
            {
              cnpj: localStorage.getItem("cnpj"),
              empresaid: localStorage.getItem("enterprise_id").toString(),
              push: {
                tipo: 2,
                tipoid:
                  this.vinculoSelecionado == null ? 5 : this.vinculoSelecionado,
                id_direcionado:
                  this.vinculoSelecionado == 2
                    ? this.promocaoSelecionada
                    : null,
                titulo: this.tituloCampanha,
                descricao: this.descricaoCampanha,
                dados: arrClientes
              }
            },
            {
              headers: {
                Accept: "application/json",
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(response => {
            if (response.status == 200) {
              this.$refs.enviarCampanha.hide();
              let toast = this.$toasted.show(
                "Campanha cadastrada com sucesso!",
                {
                  theme: "toasted-primary",
                  position: "bottom-center",
                  duration: 5000,
                  icon: "check",
                  iconPack: "fontawesome"
                }
              );
            }
          })
          .catch(error => {});
      } else {
        this.erroCampanha = true;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async getPushsDisponiveis() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-pushs-disponiveis/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.pushsDisponiveis = response.data.pushsDisponiveis;
          }
        });
    },
    async redirect() {
      this.isLoading = true;
      await this.getPushsDisponiveis();
      this.isLoading = false;
      this.$refs.enviarCampanha.show();
    },
    analiseItemSelecionado(record) {
      localStorage.setItem("id_produto", record.codbarras);
      this.$router.push({ path: `periodo/comparacao` });
      console.info({ record });
    },
    receberDados() {
      var dados = JSON.parse(localStorage.getItem("analise"));
      if (dados) {
        this.clientesFidelizados = dados.total_fidelizados;
        this.clientesNaoFidelizados = dados.total_naofidelizados;
        this.items_clientesfidelizados = dados.lista_fidelizados;
        this.items_produtoscomparados = dados.produtos;
      }
    },
    receberDatas() {
      this.periodoInicialCompras = localStorage.getItem("datacompra_inicial");
      this.periodoFinalCompras = localStorage.getItem("datacompra_final");
      this.periodoInicialAusencia = localStorage.getItem(
        "datacompraausencia_inicial"
      );
      this.periodoFinalAusencia = localStorage.getItem(
        "datacompraausencia_final"
      );
    }
  },
  async beforeMount() {
    this.isLoading = true;
    await this.receberDados();
    await this.receberDatas();
    this.isLoading = false;
  }
};
</script>